(function () {
  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function predictiveUrl(searchTerm) {
    var routes = window.theme && window.theme.routes;
    if (!routes || !routes.predictiveSearch) return null;

    var params = [
      'q=' + encodeURIComponent(searchTerm),
      'resources[limit]=4',
      'resources[limit_scope]=each',
      'section_id=search-results',
    ].join('&');

    return routes.predictiveSearch + '?' + params;
  }

  function initSearch(root) {
    if (!root || root.dataset.abSearchInit) return;
    root.dataset.abSearchInit = 'true';

    var form = root.querySelector('.ab-header-search__form');
    var input = root.querySelector('.ab-header-search__input');
    var dropdown = root.querySelector('.ab-header-search__dropdown');
    var popularPanel = root.querySelector('.ab-header-search__popular-panel');
    var predictivePanel = root.querySelector('.ab-header-search__predictive');
    if (!form || !input || !dropdown) return;

    var activeRequest = 0;

    function setDropdownOpen(open) {
      root.classList.toggle('is-open', open);
      dropdown.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    function showPopular() {
      if (popularPanel) popularPanel.hidden = false;
      if (predictivePanel) {
        predictivePanel.hidden = true;
        predictivePanel.innerHTML = '';
      }
    }

    function showPredictive(html) {
      if (!predictivePanel) return;
      if (popularPanel) popularPanel.hidden = true;
      predictivePanel.hidden = false;
      predictivePanel.innerHTML = html;
    }

    function open() {
      setDropdownOpen(true);
      if (!input.value.trim()) showPopular();
    }

    function close() {
      setDropdownOpen(false);
    }

    function fetchSuggestions() {
      var term = input.value.trim();
      if (!term.length) {
        showPopular();
        return;
      }

      var url = predictiveUrl(term);
      if (!url) return;

      var requestId = ++activeRequest;
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          if (requestId !== activeRequest) return;

          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-search-results');
          var results = section && section.querySelector('#predictive-search-results');
          if (!results) {
            showPopular();
            return;
          }

          showPredictive(results.outerHTML);
          setDropdownOpen(true);
        })
        .catch(function () {
          if (requestId !== activeRequest) return;
          showPopular();
        });
    }

    var debouncedFetch = debounce(fetchSuggestions, 280);

    input.addEventListener('focus', open);
    input.addEventListener('input', function () {
      open();
      debouncedFetch();
    });

    root.querySelectorAll('[data-ab-search-term]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = link.getAttribute('data-ab-search-term') || '';
        form.requestSubmit();
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });
  }

  function bindMobileTriggers() {
    document.querySelectorAll('[data-ab-search-focus]').forEach(function (trigger) {
      if (trigger.dataset.abSearchTriggerInit) return;
      trigger.dataset.abSearchTriggerInit = 'true';

      trigger.addEventListener('click', function () {
        var targetId = trigger.getAttribute('data-ab-search-focus');
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        target.focus();
        var wrap = target.closest('.ab-header-search');
        if (wrap) {
          wrap.classList.add('is-open');
          var dropdown = wrap.querySelector('.ab-header-search__dropdown');
          if (dropdown) dropdown.setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  function boot() {
    if (!document.documentElement.classList.contains('ab-search-bar')) return;

    document.querySelectorAll('[data-ab-header-search]').forEach(initSearch);
    bindMobileTriggers();
  }

  window.__abSearchBarBoot = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('ab-search-bar:ready', boot);

  try {
    var htmlObserver = new MutationObserver(function () {
      if (document.documentElement.classList.contains('ab-search-bar')) boot();
    });
    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  } catch (e) {}
})();
